import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78863143&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78863143')) {
      api.createRecord('78863143', component.options)
    } else {
      api.reload('78863143', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78863143&", function () {
      api.rerender('78863143', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/hot/index.vue"
export default component.exports